export default {
  setMenuContent(state, menu) {
    state.menuItems = menu;
  },
  setActiveWebsite(state, website) {
    state.activeWebsite = website;
  },
  setReloadEmail(state, value) {
    state.reloadEmail = value;
  },
};
